import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Search, X } from "lucide-react";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { useAPI } from "../../hooks/useAPI";

const SelectVisitTypeModal = ({ isOpen, onClose, onSelect, templateId }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const api = useAPI();

  useEffect(() => {
    if (isOpen) {
      loadTemplates();
    }
  }, [isOpen]);

  const loadTemplates = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/templates/${templateId}/visit-types`);
      setTemplates(data || []);
    } catch (error) {
      console.error("Error loading visit types:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredTemplates = templates.filter(
    (template) =>
      template.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.description?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Dialog open={isOpen} onOpenChange={(next) => !next && onClose()}>
      <DialogContent size="lg" hideCloseButton className="gap-0 p-0">
        <DialogHeader className="flex-row items-center justify-between space-y-0 border-b p-4 text-left">
          <DialogTitle className="text-lg font-medium">Select Visit Type Example</DialogTitle>
          <DialogClose className="text-text-disabled hover:text-muted-foreground">
            <X className="h-5 w-5" />
          </DialogClose>
        </DialogHeader>

        <div className="p-4">
          <div className="relative mb-4">
            <input
              type="text"
              placeholder="Search visit types..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full rounded-lg border py-2 pl-10 pr-4 focus-visible:shadow-focus"
            />
            <Search className="absolute left-3 top-2.5 h-5 w-5 text-text-disabled" />
          </div>

          {loading ? (
            <div className="py-4 text-center">Loading...</div>
          ) : (
            <div className="max-h-96 space-y-2 overflow-y-auto">
              {filteredTemplates.map((template) => (
                <button
                  key={template.visit_type_id}
                  onClick={() => onSelect(template)}
                  className="w-full rounded-lg border p-4 text-left hover:bg-surface-subtle"
                >
                  <div className="font-medium">{template.name}</div>
                  {template.description && (
                    <div className="text-sm text-muted-foreground">{template.description}</div>
                  )}
                  <div className="mt-1 text-xs text-text-disabled">
                    {template.detail_count} visit details
                  </div>
                </button>
              ))}
              {filteredTemplates.length === 0 && (
                <div className="py-4 text-center text-muted-foreground">
                  No matching visit types found
                </div>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

SelectVisitTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  templateId: PropTypes.string.isRequired,
};

export default SelectVisitTypeModal;
